export default [{
  mainButton: {
    name: 'reportsDays',
    label: 'Reports<br>by day',
    goTo: '/reports/days',
    tooltip: ''
  },
  fastButtons: [{
    name: 'staffFilters',
    label: 'Chart filter',
    goTo: '?modal=ReportsFilterModal'
  }, {
    name: 'uploadDownload',
    label: 'Uploading and downloading data',
    menu: [{
      name: 'download',
      label: 'Download pivot tabel',
      goTo: '?modal=downloadReports-modalPivotTabel'
    }]
  }]
}, {
  mainButton: {
    name: 'reportsIndicators',
    label: 'Indicators',
    goTo: '/reports/indicators',
    tooltip: ''
  }
} // {
//   mainButton: {
//     name: 'download',
//     label: 'Download',
//     goTo: '?modal=downloadReports-modalPivotTabel',
//     tooltip: 'Download pivot tabel'
//   }
// }
// {
//   mainButton: {
//     name: 'vacancyFiltersFree',
//     label: 'Displaying<br>by type',
//     menu: [
//       { name: 'selectAll', label: 'All', goTo: '?mbVacancy=all' },
//       { name: 'vacanciesFree', label: 'Only vacancies', goTo: '?mbVacancy=1' },
//       { name: 'vacanciesNotFree', label: 'Store shifts only', goTo: '?mbVacancy=0' }
//     ]
//   }
// }
];